export const FUNC_FORMATION_LOADER = 'FUNC_FORMATION_LOADER';
export const FUNC_SAVE_FORMATION_LOADER = 'FUNC_SAVE_FORMATION_LOADER';
export const GET_FUNC_FORMATION = 'GET_FUNC_FORMATION';